(() => {
  if (window.HiNookiHandcraftedDeliveryEstimate) return;
  const selector = '[data-hn-handcrafted-delivery-estimate]';
  const slotSelector = '[data-hn-handcrafted-delivery-slot]';
  let subscribed = false;
  let freshnessTimer;
  const sourceMaximumAge = 60 * 60 * 1000;
  const renderCopy = (copy, template, values) => {
    const nodes = template.split(/(__ORIGINS__|__START__|__END__)/g).map(part => {
      if (values[part] === undefined) return document.createTextNode(part);
      if (part === '__START__' || part === '__END__') {
        const date = document.createElement('strong');
        date.textContent = values[part];
        return date;
      }
      return document.createTextNode(values[part]);
    });
    copy.replaceChildren(...nodes);
  };
  const addDays = (today, count, businessDays) => {
    const result = new Date(today);
    result.setHours(12, 0, 0, 0);
    let elapsed = 0;
    while (elapsed < count) {
      result.setDate(result.getDate() + 1);
      if (!businessDays || (result.getDay() !== 0 && result.getDay() !== 6)) elapsed++;
    }
    return result;
  };
  const refresh = node => {
    const minimum = Number(node.dataset.hnHandcraftedMinDays);
    const maximum = Number(node.dataset.hnHandcraftedMaxDays);
    const businessValue = node.dataset.hnHandcraftedBusinessDays;
    if (!Number.isInteger(minimum) || !Number.isInteger(maximum) || minimum < 1 || maximum < minimum || maximum > 30 || !['true', 'false'].includes(businessValue)) return;
    const copy = node.querySelector('[data-hn-handcrafted-copy]');
    const template = copy?.dataset.hnHandcraftedTemplate;
    if (!template || !template.includes('__START__') || !template.includes('__END__')) return;
    const today = new Date();
    const start = addDays(today, minimum, businessValue === 'true');
    const end = addDays(today, maximum, businessValue === 'true');
    const options = { month: 'short', day: 'numeric' };
    if (start.getFullYear() !== today.getFullYear() || end.getFullYear() !== today.getFullYear()) options.year = 'numeric';
    const formatter = new Intl.DateTimeFormat('en-US', options);
    renderCopy(copy, template, { __START__: formatter.format(start), __END__: formatter.format(end) });
  };
  const slotsFor = (scope, sectionId, productId) => Array.from(scope.querySelectorAll(slotSelector)).filter(slot => slot.dataset.hnSection === String(sectionId) && slot.dataset.hnProduct === String(productId));
  const refreshSlot = slot => {
    const estimate = slot.querySelector('.hn-handcrafted-delivery-estimate');
    let hide = slot.dataset.hnPending === 'true' || !estimate;
    if (slot.dataset.hnLocalSources !== undefined) {
      const checkedAt = Number(slot.dataset.hnSourcesCheckedAt) * 1000;
      const sourceAge = new Date().getTime() - checkedAt;
      hide ||= !Number.isInteger(checkedAt) || checkedAt <= 0 || sourceAge < 0 || sourceAge > sourceMaximumAge;
      const form = document.getElementById(slot.dataset.hnForm);
      const input = form?.elements?.namedItem('quantity') || form?.querySelector('input[name="quantity"]');
      const quantity = Number(input?.value ?? 1);
      const cartQuantity = Number(input?.dataset?.cartQuantity ?? 0);
      let sources = [];
      try {
        const parsed = JSON.parse(slot.dataset.hnLocalSources);
        if (Array.isArray(parsed)) sources = parsed.filter(source =>
          source && typeof source === 'object' &&
          typeof source.origin === 'string' && typeof source.label === 'string' &&
          Number.isInteger(source.available) && source.available >= quantity + cartQuantity &&
          Number.isInteger(source.min_days) && Number.isInteger(source.max_days) &&
          source.min_days > 0 && source.max_days >= source.min_days && source.max_days <= 20 &&
          typeof source.business_days === 'boolean'
        );
      } catch {}
      hide ||= !Number.isInteger(quantity) || quantity < 1 || !Number.isInteger(cartQuantity) || cartQuantity < 0 || sources.length === 0;
      const copy = estimate?.querySelector('[data-hn-handcrafted-copy]');
      const template = copy?.dataset.hnHandcraftedTemplate;
      hide ||= !template || !template.includes('__START__') || !template.includes('__END__') || !template.includes('__ORIGINS__');
      slot.hidden = hide;
      if (hide) return;
      const today = new Date();
      const start = new Date(Math.min(...sources.map(source => addDays(today, source.min_days, source.business_days).getTime())));
      const end = new Date(Math.max(...sources.map(source => addDays(today, source.max_days, source.business_days).getTime())));
      const options = { month: 'short', day: 'numeric' };
      if (start.getFullYear() !== today.getFullYear() || end.getFullYear() !== today.getFullYear()) options.year = 'numeric';
      const formatter = new Intl.DateTimeFormat('en-US', options);
      const names = [...new Map(sources.map(source => [source.origin, source.label])).values()];
      renderCopy(copy, template, {
        __ORIGINS__: names.join(slot.dataset.hnOriginSeparator || ' or '),
        __START__: formatter.format(start),
        __END__: formatter.format(end)
      });
      return;
    }
    const rawLimit = slot.dataset.hnStockLimit;
    if (!hide && rawLimit !== undefined && rawLimit !== '') {
      const limit = Number(rawLimit);
      const form = document.getElementById(slot.dataset.hnForm);
      const input = form?.elements?.namedItem('quantity') || form?.querySelector('input[name="quantity"]');
      const quantity = Number(input?.value ?? 1);
      const cartQuantity = Number(input?.dataset?.cartQuantity ?? 0);
      hide = !Number.isFinite(limit) || !Number.isFinite(quantity) || !Number.isFinite(cartQuantity) || quantity < 1 || cartQuantity < 0 || quantity + cartQuantity > limit;
    }
    slot.hidden = hide;
    if (!hide && estimate.matches(selector)) refresh(estimate);
  };
  const scheduleFreshnessCheck = () => {
    if (freshnessTimer !== undefined) window.clearTimeout?.(freshnessTimer);
    freshnessTimer = undefined;
    const now = new Date().getTime();
    let nextExpiry = Infinity;
    document.querySelectorAll(slotSelector).forEach(slot => {
      if (slot.dataset.hnLocalSources === undefined) return;
      const checkedAt = Number(slot.dataset.hnSourcesCheckedAt) * 1000;
      const expiry = checkedAt + sourceMaximumAge + 1;
      if (Number.isInteger(checkedAt) && checkedAt > 0 && checkedAt <= now && expiry > now) nextExpiry = Math.min(nextExpiry, expiry);
    });
    if (Number.isFinite(nextExpiry)) freshnessTimer = window.setTimeout?.(() => refreshAll(), nextExpiry - now);
  };
  const subscribeTheme = () => {
    const bus = window.theme?.pubsub;
    const events = bus?.PUB_SUB_EVENTS;
    if (subscribed || !bus?.subscribe || !events?.optionValueSelectionChange || !events?.variantChange) return;
    subscribed = true;
    bus.subscribe(events.optionValueSelectionChange, message => {
      const target = message?.data?.event?.target || message?.data?.target;
      const owner = target?.closest?.('product-info, product-card-info');
      if (!owner) return;
      const sectionId = owner.getAttribute('data-original-section-id') || owner.getAttribute('data-section-id');
      const productId = owner.getAttribute('data-product-id');
      slotsFor(document, sectionId, productId).forEach(slot => {
        slot.dataset.hnPending = 'true';
        slot.hidden = true;
      });
    });
    bus.subscribe(events.variantChange, message => {
      const data = message?.data;
      if (!data?.sectionId || !data?.productId) return;
      const replacements = data.parsedHTML?.querySelectorAll ? slotsFor(data.parsedHTML, data.sectionId, data.productId) : [];
      slotsFor(document, data.sectionId, data.productId).forEach(slot => {
        const replacement = replacements.find(node => node.dataset.hnForm === slot.dataset.hnForm && node.dataset.hnVariant === String(data.variant?.id));
        if (!replacement) {
          slot.dataset.hnPending = 'true';
          slot.hidden = true;
          slot.replaceChildren();
          return;
        }
        const fresh = replacement.cloneNode(true);
        fresh.dataset.hnPending = 'false';
        if (!data.variant?.available) fresh.replaceChildren();
        slot.replaceWith(fresh);
        refreshSlot(fresh);
      });
      scheduleFreshnessCheck();
    });
    if (events.quantityUpdate) bus.subscribe(events.quantityUpdate, () => document.querySelectorAll(slotSelector).forEach(refreshSlot));
  };
  const refreshAll = (scope = document) => {
    subscribeTheme();
    if (scope.matches?.(selector)) refresh(scope);
    scope.querySelectorAll(selector).forEach(refresh);
    if (scope.matches?.(slotSelector)) refreshSlot(scope);
    scope.querySelectorAll(slotSelector).forEach(refreshSlot);
    scheduleFreshnessCheck();
  };
  window.HiNookiHandcraftedDeliveryEstimate = { refreshAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refreshAll(), { once: true });
  else refreshAll();
  document.addEventListener('shopify:section:load', event => refreshAll(event.target));
  document.addEventListener('product-info:loaded', () => refreshAll());
  const onQuantityChange = event => {
    const input = event.target;
    if (!input?.matches?.('input[name="quantity"]')) return;
    const formId = input.form?.id || input.getAttribute('form');
    if (!formId) return;
    document.querySelectorAll(slotSelector).forEach(slot => {
      if (slot.dataset.hnForm === formId) refreshSlot(slot);
    });
  };
  document.addEventListener('input', onQuantityChange);
  document.addEventListener('change', onQuantityChange);
  window.addEventListener('load', () => refreshAll());
  window.addEventListener('pageshow', () => refreshAll());
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshAll(); });
})();


